module.exports = __webpack_public_path__ + "img/project1_small.f609996f.webp";